import { render } from "./Qualifications.vue?vue&type=template&id=31ef61c0&scoped=true&ts=true"
import script from "./Qualifications.vue?vue&type=script&lang=ts"
export * from "./Qualifications.vue?vue&type=script&lang=ts"

import "./Qualifications.vue?vue&type=style&index=0&id=31ef61c0&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ef61c0"]])

export default __exports__